/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Museum',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <g fill="currentColor">
            <path
              fillRule="evenodd"
              d="M18.457 3.182c1.985.02 3.589 1.635 3.589 3.625-.001 1.861-1.404 3.393-3.21 3.6v9.815a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6v-9.943c-.774-.311-1.32-1.067-1.32-1.952 0-.35.086-.68.237-.97H7.446c.151.29.237.62.237.97 0 .851-.505 1.581-1.231 1.913v9.982a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6v-9.807c-1.849-.165-3.297-1.717-3.298-3.608 0-1.999 1.618-3.621 3.616-3.625v-.003h12.886v.003zM5.58 4.381c-1.339 0-2.426 1.086-2.426 2.426S4.24 9.23 5.579 9.23c.5 0 .905-.405.905-.904s-.406-.905-.905-.905a.6.6 0 0 1-.562-.392c-.042-.082-.067-.174-.067-.272a.6.6 0 0 1 .601-.6H18.45a.6.6 0 0 1 .6.6c0 .098-.027.188-.068.27-.084.229-.302.394-.561.395-.5 0-.905.406-.905.905s.406.905.905.905a2.43 2.43 0 0 0 2.426-2.425c0-1.339-1.087-2.426-2.426-2.426L5.588 4.38z"
            />
            <use href="#B" />
            <path d="M10.859 9.087a.6.6 0 0 1 .601.601v10.47a.6.6 0 0 1-1.2 0V9.688a.6.6 0 0 1 .599-.601zm2.37 0a.6.6 0 0 1 .6.601v10.47a.6.6 0 0 1-1.2 0V9.688a.6.6 0 0 1 .6-.601z" />
            <use
              href="#B"
              x="7.109"
            />
          </g>
          <defs>
            <path
              id="B"
              d="M8.49 10.937a.6.6 0 0 1 .6.601v8.62a.6.6 0 0 1-.6.6.6.6 0 0 1-.6-.6v-8.62a.6.6 0 0 1 .6-.601z"
            />
          </defs>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
